import type { CommonError } from '@/dto/common/CommonError'
import { commonErrorMessage, toastError } from '@/utils/toast'

// 응답 없는 네트워크 실패는 code 없이 type 만 있으므로 둘 중 하나면 CommonError 로 본다
const isCommonErrorLike = (error: unknown): error is CommonError =>
  typeof error === 'object' && error !== null && ('code' in error || 'type' in error)

// 예약 규칙 위반은 BE 가 사용자용 한국어 message 를 내려주므로 그대로 보여준다
export const isScheduleRuleError = (error: unknown): error is CommonError =>
  isCommonErrorLike(error) &&
  typeof error.code === 'string' &&
  (error.code.startsWith('ASSIGN_SCHEDULE_') ||
    error.code === 'WORKSHEET_ALREADY_SCHEDULED_EXCEPTION' ||
    error.code === 'DUPLICATED_ASSIGN_SCHEDULE_EXCEPTION')

export const toastScheduleError = (error: unknown) => {
  if (isScheduleRuleError(error) && error.message) {
    toastError(error.message)
  } else {
    commonErrorMessage(isCommonErrorLike(error) ? error : undefined)
  }
}
